import clsx from 'clsx';

import Toggle from '@app/components/toggle';
import Tooltip from '@app/components/tooltip';
import { T } from '@app/components/translation';

import { EidSigningMethod } from 'types/electronic-id';

import style from './electronic-id.module.scss';

interface ElectronicIdSigningMethodsProps {
  canUpdate: boolean;
  onEidToggle: (key: string) => void;
  isEnabled: boolean;
  signingMethods?: EidSigningMethod[];
}

export const ElectronicIdSigningMethods: React.FC<ElectronicIdSigningMethodsProps> = ({
  canUpdate,
  onEidToggle,
  isEnabled,
  signingMethods = [],
}) => {
  if (!canUpdate) {
    return (
      <Tooltip
        message={
          <T
            _str="Contact your administrator to enable"
            _comment="Tooltip message for enabling an extension when something blocks the action"
          />
        }
        side="right"
      >
        <Toggle
          className={style.Toggle}
          onChange={onEidToggle}
          disabled
          version="latest"
        />
      </Tooltip>
    );
  }

  const isDisabled = !isEnabled || !canUpdate;

  return (
    <div className={style.SigningMethodsContainer}>
      {signingMethods.length > 0 &&
        signingMethods.map((signingMethod) => (
          <div
            className={style.SigningMethodContainer}
            key={signingMethod.key}
          >
            <Toggle
              checked={Boolean(signingMethod.isChecked)}
              className={style.Toggle}
              onChange={() => onEidToggle(signingMethod.key)}
              disabled={isDisabled}
              version="latest"
            />
            {Boolean(signingMethod.label) && (
              <Tooltip
                message={signingMethod.description}
                side="right"
              >
                <div
                  className={clsx(style.SigningMethodLabel, style[signingMethod.label], {
                    [style.Disabled]: isDisabled,
                  })}
                >
                  {signingMethod.label}
                </div>
              </Tooltip>
            )}
          </div>
        ))}
    </div>
  );
};
